export const createRequestPayloadForInventoryService = (
  frontQuantity,
  rearQuantity,
  brand,
  frontTireBvId,
  rearTireBvId,
  requestedStore
) => {
  // These 2 are the static values that will be useful for future
  // but for now they dont need any dynamic values but required to be send with the reqPayload
  const commonStaticValues = {
    requestedDateTime: '06-30-2023 18:08:20',
    requestedTimeZone: 'America/Chicago'
  }

  if (frontTireBvId && rearTireBvId) {
    return {
      partNumbers: [
        {
          partNumber: frontTireBvId,
          quantity: frontQuantity,
          brand: brand.toUpperCase()
        },
        {
          partNumber: rearTireBvId,
          quantity: rearQuantity,
          brand: brand.toUpperCase()
        }
      ],
      requestedStore,
      ...commonStaticValues
    }
  }

  return {
    partNumbers: [
      {
        partNumber: frontTireBvId || rearTireBvId,
        quantity: frontQuantity || rearQuantity,
        brand: brand.toUpperCase()
      }
    ],
    requestedStore,
    ...commonStaticValues
  }
}

